import { language } from "language/default";
const getGroups = (level, key, parent) => {
    if (level < 0 || !parent) {
        return [];
    }
    return [key || "", ...getGroups(parent?.level, parent.key, parent.parent)];
};
export const getTotal = (node, total, variation) => {
    let totals = total;
    if (node.level === -1) {
        return variation && totals?.value ? totals.value[variation] : totals?.value;
    }
    else if (node.level >= 0) {
        const groups = getGroups(node.level, node.key, node.parent);
        for (const group of groups.reverse()) {
            if (!totals?.children) {
                return "";
            }
            totals = totals.children[group];
        }
        return variation && totals?.value ? totals.value[variation] : totals?.value;
    }
    return "";
};
export const InsGridAggs = {
    putStringValueTotalsInColumnFooter: "putStringValueTotalsInColumnFooter",
    totalData: "totalDataSourceAsAgg"
};
export const customAggFuncs = {
    [InsGridAggs.totalData]: (params) => {
        const totalData = params.context?.totals;
        const { field } = params.colDef;
        if (totalData && field && params.rowNode.group) {
            const totals = totalData[field];
            if (totals) {
                return getTotal(params.rowNode, totals);
            }
            const [totalField, variation] = field.split(".");
            if (variation && totalData[totalField]) {
                return getTotal(params.rowNode, totalData[totalField], variation);
            }
        }
        return null;
    },
    /*
     * Temporary easier way to put the total string in column 0 when aggFunc totalDataSourceAsAgg is applied
     * RowNode level less than zero means that it is footer row.
     * RowNode leafGroup to true on footer row means that the grouping is not active on this grid
     */
    [InsGridAggs.putStringValueTotalsInColumnFooter]: (params) => {
        if (params.rowNode.level < 0 && params.rowNode.leafGroup) {
            return language.en.common.total;
        }
        return null;
    },
    idToNameAggFunc: (params) => {
        const fieldPath = params.context?.linksMapping?.find((m) => m.id === params.colDef.field)?.field;
        if (fieldPath && Array.isArray(params.rowNode.allLeafChildren)) {
            const [child] = params.rowNode.allLeafChildren;
            return child?.data[fieldPath];
        }
        return null;
    }
};
